import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Ratingusa = () => {
  return (
    <div
      className="rating_usa rating_web_dev rating_dubai rating_on_demand p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <h2 className="text-center" style={{ marginBottom: "20px" }}>
              Our Track Record in <span>NLP Solutions</span>
            </h2>
          </Col>
        </Row>

        <Row className="h-100 mt-sm-3 mt-md-4">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={11}
            xxl={10}
            className="m-auto text-center"
          >
            <Row>
              <Col xs={6} md={6} lg={6} xl={3} xxl={3}>
                <div className="rating_box">
                  <div className="rating-content">
                    <div className="rating-num">20+</div>
                    <p>AI & NLP Specialists</p>
                  </div>
                </div>
              </Col>
              <Col xs={6} md={6} lg={6} xl={3} xxl={3}>
                <div className="rating_box">
                  <div className="rating-content">
                    <div className="rating-num">30+</div>
                    <p>Custom NLP Models</p>
                  </div>
                </div>
              </Col>
              <Col xs={6} md={6} lg={6} xl={3} xxl={3}>
                <div className="rating_box">
                  <div className="rating-content">
                    <div className="rating-num">90%</div>
                    <p>Sentiment Accuracy</p>
                  </div>
                </div>
              </Col>
              <Col xs={6} md={6} lg={6} xl={3} xxl={3}>
                <div className="rating_box">
                  <div className="rating-content">
                    <div className="rating-num">30%</div>
                    <p>Cost Efficiency in Support</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ratingusa;
